import { Skeleton } from 'antd';
import { Row } from 'farmhub-ui-core';

const TaskItemSkeleton = () => (
  <Row
    alignItems="center"
    justifyContent="space-between"
    styles={{ padding: '12px 0px' }}
    width="100%"
  >
    <Row styles={{ gap: 6 }} width="fit-content">
      <Skeleton.Input style={{ width: 32, height: 32, borderRadius: '6px' }} />
      <Skeleton.Input size="small" style={{ width: 84 }} />
    </Row>

    <Row styles={{ gap: 6 }} width="fit-content">
      <Skeleton.Input size="small" style={{ width: 48 }} />
      <Skeleton.Input size="small" style={{ width: 48 }} />
    </Row>
  </Row>
);

export default TaskItemSkeleton;
